import BecomeCreatorPage from './BecomeCreatorPage';

export default BecomeCreatorPage;
